module.exports = __webpack_public_path__ + "img/stzl1.2436a765.png";